import { useState } from "react";
import PortfolioList from "../portfolioList/PortfolioList";
import "./portfolio.scss";

const list = [
  { id: "featured", title: "Featured" },
  { id: "ai", title: "AI & Agentic" },
  { id: "mobile", title: "Mobile & AR" },
  { id: "ds", title: "Data Science" },
];

const projects = {
  featured: [
    {
      title: "Voice-to-Estimate — AI-Powered Mobile Estimation",
      desc: "AI-driven voice recognition for a mobile estimation app used by contractors and insurers. NLP and context-aware LLM processing match spoken input against a structured item database and auto-populate floor, roof, and exterior diagrams with accurate cost estimates.",
      tech: ["Swift", "SwiftUI", "LLM APIs", "NLP", "iOS"],
    },
    {
      title: "Agentic Developer Workflow — Autonomous Issue Resolution",
      desc: "End-to-end agentic pipeline connecting Claude and GitHub Copilot to live Jira/Fogbugz backlogs via MCP — autonomously retrieves ticket context, plans a resolution, generates code fixes, and surfaces results to developers.",
      tech: ["MCP", "Claude API", "GitHub Copilot", "Node.js", "Jira API"],
    },
    {
      title: "iOS LiDAR Room Scanning — AR Object Placement",
      desc: "AR feature leveraging the iPhone/iPad LiDAR sensor to scan physical rooms and auto-place detected objects into estimation diagrams, mapping spatial geometry to structured blueprint objects.",
      tech: ["Swift", "ARKit", "RealityKit", "Core ML", "LiDAR"],
    },
    {
      title: "Secure Developer Workstation Onboarding",
      desc: "Standardized SSH tunneling workflow using 1Password's SSH Agent for key-based macOS authentication — zero-credential-exposure onboarding for development teams.",
      tech: ["SSH", "1Password SSH Agent", "Bash", "macOS"],
    },
  ],
  ai: [
    {
      title: "Voice-to-Estimate — AI-Powered Mobile Estimation",
      desc: "Voice-driven NLP pipeline that parses spoken contractor/insurance input and applies LLM-based matching against a structured item database to generate accurate line-item estimates.",
      tech: ["LLM APIs", "NLP", "Swift", "REST APIs"],
    },
    {
      title: "Agentic Developer Workflow — Autonomous Issue Resolution",
      desc: "Multi-step autonomous planning and tool use: agents retrieve live backlog context, plan fixes, generate code, and report back — reducing manual developer overhead.",
      tech: ["MCP", "Claude API", "GitHub Copilot", "Prompt Engineering"],
    },
    {
      title: "Tic-Tac-Toe AI — Monte Carlo Tree Search",
      desc: "Python AI agent using Monte Carlo Tree Search (MCTS) for advanced strategic gameplay, significantly reducing the human win rate.",
      tech: ["Python", "MCTS Algorithm"],
    },
  ],
  mobile: [
    {
      title: "iOS LiDAR Room Scanning — AR Object Placement",
      desc: "Augmented reality feature mapping spatial geometry from LiDAR scans to structured blueprint objects, improving on-site measurement accuracy.",
      tech: ["Swift", "SwiftUI", "ARKit", "RealityKit", "LiDAR"],
    },
    {
      title: "Shared C++ Diagramming Engine — Desktop to Mobile",
      desc: "Extracted the core C++ diagramming library from a legacy Windows desktop app and integrated it into the iOS backend, unifying floor/roof/exterior diagramming logic across platforms.",
      tech: ["C++", "Swift", ".NET", "MFC", "Xcode"],
    },
    {
      title: "SimpleScanner — Warehouse Barcode Tracking",
      desc: "Android app for warehouse bin and item tracking via intelligent barcode detection, replacing legacy Telnet-based tools for 40+ warehouse staff.",
      tech: ["Android", "Kotlin", "REST APIs", "Azure"],
    },
    {
      title: "AmazShip — Amazon Shipment Logistics App",
      desc: "Mobile app tracking item-to-box-to-skid mapping for Amazon shipments, capturing ASN-compliant data and reducing fulfillment errors.",
      tech: ["Android", "Kotlin", "REST APIs", "MSSQL"],
    },
  ],
  ds: [
    {
      title: "COVID-19 Detection via Deep Learning",
      desc: "Deep neural network analyzing chest scans to differentiate COVID-19 from Pneumonia, enhancing early diagnostic accuracy.",
      tech: ["Python", "TensorFlow", "PyTorch", "Jupyter"],
    },
    {
      title: "Targeted Banking Marketing Analysis",
      desc: "Machine learning applied to Canadian bank customer data to identify segments for personalized marketing, improving conversion targeting.",
      tech: ["Python", "Scikit-learn", "Pandas", "Jupyter"],
    },
    {
      title: "US Election Demographic Analysis",
      desc: "Analyzed county-level voting and demographic data to discover patterns influencing voter turnout and pre-poll accuracy.",
      tech: ["Python", "Pandas", "Matplotlib", "Jupyter"],
    },
    {
      title: "Tic-Tac-Toe AI — Monte Carlo Tree Search",
      desc: "Strategic game-playing agent built with MCTS, demonstrating search-based decision-making algorithms.",
      tech: ["Python", "MCTS Algorithm"],
    },
  ],
};

export default function Portfolio() {
  const [selected, setSelected] = useState("featured");

  return (
    <div className="portfolio" id="portfolio">
      <h1>Portfolio</h1>
      <p className="subtitle">
        Selected projects across AI, agentic systems, mobile/AR, and data
        science.
      </p>
      <ul>
        {list.map((item) => (
          <PortfolioList
            key={item.id}
            id={item.id}
            title={item.title}
            active={selected === item.id}
            setSelected={setSelected}
          />
        ))}
      </ul>
      <div className="container">
        {projects[selected].map((p) => (
          <div className="item" key={p.title}>
            <h3>{p.title}</h3>
            <p>{p.desc}</p>
            <div className="tags">
              {p.tech.map((t) => (
                <span key={t}>{t}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
